module.exports = "/_next/static/media/2ff09d3fd94d6027cdc2915f56b4aff3.svg";